import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MealnoLanding from "./MealnoLanding";
import AppReview from "./AppReview"; // Make sure the file name matches

function App() {
    return (
        <Router>
            <Routes>
                {/* The main landing page is shown on the default route "/" */}
                <Route path="/" element={<MealnoLanding />} />

                {/* The review page is shown on the "/review" route */}
                <Route path="/review" element={<AppReview />} />
            </Routes>
        </Router>
    );
}

export default App;